
import React from "react";
import cx from "classnames";
import { Row, Col } from "react-bootstrap";
import TextareaAutosize from "react-autosize-textarea";
import SwitchButton from "src/components/switchButton";
import isEqual from "is-equal";
import { guid } from "../../../../services/utils";

import DraggableTagView from "../components/ListFields/draggable";
import styles from "./DetailsView.module.scss";
import _ from "lodash";
import { localizedStrings } from "../.../../../../../../localization";
import { DndContext, MouseSensor, useSensor, useSensors } from "@dnd-kit/core";
import {
  arrayMove,
  rectSortingStrategy,
  SortableContext,
} from "@dnd-kit/sortable";
import { InputWithIcon } from "src/components/input";

class DetailsView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      options: [],
    };


    this.handleChangeOption = this.handleChangeOption.bind(this);
    this.onToggleChange = this.onToggleChange.bind(this);
    this.arrangeOptions = this.arrangeOptions.bind(this);
    this.handleDeleteOption = this.handleDeleteOption.bind(this);
    this.handleDragEnd = this.handleDragEnd.bind(this);
    this._handleAddValueClick = this._handleAddValueClick.bind(this);

    this.localizedKeywords = localizedStrings.keywords;
    this.localizedCommons = localizedStrings.commons;
    this.localizedLoading = this.localizedCommons.loading;
    this.localizedCommonsActions = this.localizedCommons.actions;
    this.localizedSettings = localizedStrings.pages.settings;
    this.localizedCustomFields = this.localizedSettings.account.custom_fields;
  }

  _handleAddValueClick() {
    let options = this.state.options;
    let item = {
      id: guid(),
      value: this.localizedCustomFields.untitled,
    };
    options.splice(0, 0, item);

    this.setState({
      options: options,
    });
  }

  onToggleChange(field,value) {

    this.props.onFieldChange(field, value);
  }

  componentDidMount() {
    if (this.props.item.options) {
      this.setState({
        options: this.props.item.options,
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!isEqual(this.state.options, nextProps.item.options)) {
      this.setState({
        options: nextProps.item.options,
      });
    }
  }

  handleDeleteOption(option) {
    let options = this.state.options.filter((item) => item.id !== option.id);

    this.setState({
      options: options,
    });
    this.props.onFieldChange("options", options);
  }

  handleChangeOption(option) {
    let options = this.state.options.map((x) =>
      x.id === option.id ? option : x,
    );
    this.setState({
      options: options,
    });
    this.props.onFieldChange("options", options);
  }

  arrangeOptions(dragItem, hoverItem) {
    const dragSlide = this.state.options[dragItem.index];

    if (dragSlide) {
      const options = [...this.state.options];
      options.splice(dragItem.index, 1);
      options.splice(hoverItem.index, 0, dragSlide);

      this.setState({
        options: options,
      });
      this.props.onFieldChange("options", options);
    }
  }

  _handleChange(field, e) {
    var value = e.target.value;

    this.props.onFieldChange(field, value);
  }

  handleDragEnd(event) {
    const { active, over } = event;
    if (over && active &&(active.id !== over.id)) {
      const oldIndex = this.state.options.findIndex(
        (item) => item.id === active.id,
      );
      const newIndex = this.state.options.findIndex(
        (item) => item.id === over.id,
      );
      const updatedOptions = arrayMove(this.state.options, oldIndex, newIndex);
      this.setState({ options: updatedOptions });
      this.props.onFieldChange("options", updatedOptions);
    }
  }

  render() {
    return (
      <div className={styles.content}>
        <h4 className={styles.heading}>
          {this.props.creating
            ? this.localizedCustomFields.create_custom_field.actions
                .create_custom_field
            : this.localizedCustomFields.create_custom_field.actions
                .update_custom_field}
        </h4>
        <Row className={cx(styles.row)}>
          <Col md={12} lg={12} xl={12}>
            <InputWithIcon
              value={this.props.item.name}
              onChange={this._handleChange.bind(this, "name")}
              disabled={!_.isEmpty(this.props.item.integrationType)}
              placeholder={
                this.localizedCustomFields.create_custom_field.field_name
              }
            />
            <span className={styles.error}>{this.props.errors.name || ""}</span>

          </Col>

          <Col md={12} lg={12} xl={12} className={styles.textArea}>
            <TextareaAutosize
              className={styles.helpText}
              rows={4}
              value={this.props.item.helpText}
              placeholder={
                this.localizedCustomFields.create_custom_field.help_text
                  .placeholder
              }
              spellCheck={true}
              onChange={this._handleChange.bind(this, "helpText")}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <div className={styles.listOptionsContainer}>
              <div className={styles.label}>
                {this.localizedCustomFields.create_custom_field.list_value}:
              </div>
              {_.isEmpty(this.props.item.integrationType) && (
                <div
                  className={cx(styles.action, styles.add)}
                  onClick={this._handleAddValueClick}
                >
                  <i className="paperflite-add" />
                  <span>{this.localizedCustomFields.create_custom_field.add_values}</span>
                </div>
              )}

              <div className={cx(styles.sectionsList)}>
                <DNDContext
                  onDragEnd={this.handleDragEnd}
                  items={this.state.options.map((item) => item.id)}
                >
                  {this.renderItems()}
                </DNDContext>
              </div>
              <span className={styles.error}>
                {this.props.errors.options || ""}
              </span>
            </div>

            <div className={styles.multiSelect}>
              <span className={styles.label}>
                {
                  this.localizedCustomFields.create_custom_field
                    .allow_multi_select
                }
                :
              </span>
              <div className={styles.switchButton}>
                <SwitchButton
                  id="allowMultiSelect"
                  disabled={this.props.item.options.length < 2}
                  className={styles.switchButton}
                  checked={this.props.item.multiselect && this.props.item.options.length > 1}
                  handleCheck={()=>this.onToggleChange("multiselect",!this.props.item.multiselect)}
                />
              </div>
            </div>

            <div className={styles.multiSelect}>
              <span className={styles.label}>
                {this.localizedCustomFields.create_custom_field.show_in_search}:
              </span>
              <div className={styles.switchButton}>
                <SwitchButton
                  id="showInSearchPage"
                  label=""
                  className={styles.switchButton}
                  defaultChecked={this.props.item.searchable}
                  checked={this.props.item.searchable}
                  handleCheck={()=>this.onToggleChange("searchable",!this.props.item.searchable)}
                />
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }

  renderItems() {
    const { options } = this.state;
    return options.map((option, index) => {
      return (
        <DraggableTagView
          key={index}
          name="options_field"
          placeholder=""
          optionComponent={null}
          isLoading={false}
          index={index}
          option={option}
          onChange={(e) => this.handleChangeOption(e)}
          onDelete={this.handleDeleteOption}
          integrationType={this.props.item.integrationType}
        />
      );
    });
  }
}

export default DetailsView;

function DNDContext(props) {
  const mouseSensor = useSensor(MouseSensor, {
    activationConstraint: {
      distance: 10,
    },
  });
  const sensors = useSensors(mouseSensor);
  return (
    <DndContext sensors={sensors} onDragEnd={props.onDragEnd}>
      <SortableContext items={props.items} strategy={rectSortingStrategy}>
        {props.children}
      </SortableContext>
    </DndContext>
  );
}
